import { Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import BusinessCenterOutlinedIcon from "@material-ui/icons/BusinessCenterOutlined";
import { InternalValuationReviewStore } from "../stores/internalValuationReviewStore";
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import { Document } from "@roc/feature-types";
import { useDocumentStore, WithDocumentActions } from "@roc/feature-documents";
import { CloudDownload } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  subjectPropertyInfoCard: {
    height: "500px",
    padding: "10px",
  },
  iconBox: {
    backgroundColor: "#E4E8EB",
    borderRadius: "100%",
    width: "2.5rem",
    height: "2.5rem",
  },
  button: {
    minWidth: "185px",
  }
}));

interface SubjectPropertyInformationCardHeaderProps {
  internalValuationReviewStore: InternalValuationReviewStore;
  generateReport: () => void;
  document?: Document;
}

export default function SubjectPropertyInformationCardHeader({ internalValuationReviewStore, generateReport, document }: SubjectPropertyInformationCardHeaderProps) {
  const classes = useStyles();
  const { documentStore } = useDocumentStore();

  const saveHandler = () => {
    internalValuationReviewStore.saveInternalValuationReview();
  }

  const generateReportHandler = () => {
    generateReport();
  }

  const downloadAppraisalReportHandler = () => {
    internalValuationReviewStore.downloadAppraisalReport();
  }

  const onDownloadReport = () => {
    documentStore.downloadDocument(document);
  }

  const readOnly = !!internalValuationReviewStore.readOnly;

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="center">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          className={classes.iconBox}
        >
          <BusinessCenterOutlinedIcon />
        </Box>
        <Typography variant="h5" style={{ marginLeft: "1rem" }}>
          Subject Property Information
        </Typography>
      </Box>
    </Box>
  );
}
